/**
 * @generated SignedSource<<0c9ef390510e5d6f5927ffcc13cc973f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addPrintingMethodPanel_PrintTypesListQuery$variables = Record<PropertyKey, never>;
export type addPrintingMethodPanel_PrintTypesListQuery$data = {
  readonly printTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly printTypeID: number;
      };
    }> | null;
  } | null;
};
export type addPrintingMethodPanel_PrintTypesListQuery = {
  response: addPrintingMethodPanel_PrintTypesListQuery$data;
  variables: addPrintingMethodPanel_PrintTypesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "PrintTypesConnection",
    "kind": "LinkedField",
    "name": "printTypes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintTypesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "printTypeID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "printTypes(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addPrintingMethodPanel_PrintTypesListQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addPrintingMethodPanel_PrintTypesListQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "db009cd4f3e915d51f3e6cb18b1e0cb9",
    "id": null,
    "metadata": {},
    "name": "addPrintingMethodPanel_PrintTypesListQuery",
    "operationKind": "query",
    "text": "query addPrintingMethodPanel_PrintTypesListQuery {\n  printTypes(first: 200) {\n    edges {\n      node {\n        id\n        printTypeID\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4e67bdc7b406a40fb2499511ff711ab";

export default node;
